import { render, staticRenderFns } from "./SmallArrowDown.vue?vue&type=template&id=88f16dae"
import script from "./SmallArrowDown.vue?vue&type=script&lang=js"
export * from "./SmallArrowDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports